// For use in printing components, this function is used to wrap text at 40 characters.
export const longStringProtection: (value: string, wrapAt: number) => string = (value, wrapAt) => {
    if (!value || value.length < wrapAt) return value;
    // arbitrary text wrapping at wrapAt characters
    let isItTheEnd = wrapAt;
    let shallow_val = value.slice();
    while (isItTheEnd < shallow_val.length) {
        shallow_val = `${shallow_val.substring(0, isItTheEnd)}\n${shallow_val.substring(isItTheEnd)}`;
        isItTheEnd += wrapAt + 1; // wrapAt + 1
    }
    return shallow_val;
};
